import { jsx as l } from "react/jsx-runtime";
import p from "../../ui-kit/theme-button.mjs";
import { buyOffer as d } from "../../pages/checkout/api/index.mjs";
import { BadRequest as b } from "@systemeio/util";
import { useStore as y } from "../../store/index.mjs";
import { twJoin as w } from "tailwind-merge";
function S({
  isFetching: e,
  buttonTitle: n,
  setIsFetching: o,
  preSubmit: i,
  handleBadRequest: a,
  hasErrors: f,
  buttonDisabled: m
}) {
  const { locale: s } = y(), c = async (u) => {
    u.preventDefault(), o(!0);
    try {
      const t = i();
      if (!t) return;
      const { redirect: r } = await d(t, s);
      r && (window.location.href = r);
    } catch (t) {
      if (t instanceof b)
        a(t);
      else
        throw t;
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ l(
    p,
    {
      disabled: m,
      className: w("main-transition-colors", f && "bg-danger focus:bg-danger"),
      onClick: c,
      isFetching: e,
      type: "submit",
      children: n
    }
  );
}
export {
  S as DefaultPaymentButton
};
